import { connect } from 'react-redux';
import FMComponent from '../components/FileManager/FileManager';
import {
  closeFileManager,
  selectMenu,
  newConcept,
  forkConcept,
  toggleSharedConcept,
  openRevision,
  saveRevision,
  loadConcepts,
} from '../actions/filemanager';

const mapStateToProps = (state) => {
  return {
    ...state.filemanager,
    currentSpecificationId: state.app.specification.id,
    currentSpecificationName: state.app.specification.name,
    allowCompetition: state.app.simulationAllowed,
    studentId: state.auth.studentIdNumber,
    isTeacher: state.auth.isTeacher,
  };
};

const FileManager = connect(mapStateToProps, {
  selectMenu,
  newConcept,
  forkConcept,
  toggleSharedConcept,
  openRevision,
  saveRevision,
  closeFileManager,
  loadConcepts,
})(FMComponent);

export default FileManager;
